import { render } from "./boto-integraes.vue?vue&type=template&id=29c9068d&scoped=true"
const script = {}

import "./boto-integraes.vue?vue&type=style&index=0&id=29c9068d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c9068d"]])

export default __exports__